import { createSlice } from '@reduxjs/toolkit';

export const INVITE_RSVP_ACCEPTED = 'accepted';
export const INVITE_RSVP_DECLINED = 'declined';

const inviteRsvpSlice = createSlice({
  name: 'inviteRsvp',
  initialState: {
    statusByToken: {},
  },
  reducers: {
    setInviteRsvpStatusForToken: (state, action) => {
      const { token, status } = action.payload || {};
      if (!token || !status) {
        return;
      }
      state.statusByToken[token] = status;
    },
    clearInviteRsvpStatusForToken: (state, action) => {
      const token = action.payload?.token;
      if (!token) {
        return;
      }
      delete state.statusByToken[token];
    },
    clearInviteRsvpStatuses: (state) => {
      state.statusByToken = {};
    },
  },
});

const selectInviteRsvpStatusForToken = (state, token) => state.inviteRsvp?.statusByToken?.[token] || null;

export const { setInviteRsvpStatusForToken, clearInviteRsvpStatusForToken, clearInviteRsvpStatuses } = inviteRsvpSlice.actions;
export { selectInviteRsvpStatusForToken };
export default inviteRsvpSlice.reducer;
